export default __webpack_public_path__ + "static/media/LinkedIn.a185607e.svg";